import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ServiceHead.css";

const ServicesHead = () => {
  return (
    <div fluid className="services-head-container">
      <Row className="services-head-row">
        <Col
          lg={6}
          md={12}
          className="services-head-text leftheaderinservicespage"
        >
          <h6 className="services-head-subtitle">Who we serve</h6>
          <h2 className="services-head-title" style={{ color: "white" }}>
            Our expertise spans a broad continuum of providers including
          </h2>
          <div className="services-head-table-container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Individual Physicians
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Therapists
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    DME Suppliers
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Ambulatory Surgery Centers
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Ambulance Services
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Acute Care Hospitals
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    CAH'S
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Emergency Units
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Urgent Care Centers
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Radiology Centers
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>

        <Col lg={6} md={12} className="services-head-text">
          <h6 className="services-head-subtitle">What we serve</h6>
          <h2 className="services-head-title" style={{ color: "white" }}>
            Our commitment is to deliver excellence with every Service we offer.
          </h2>
          <div className="services-head-table-container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Front end
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Coding
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Backend
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Credentialing
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Specialty Billing
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Telemedicine
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Analytics
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Technology
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ServicesHead;
